export default "__VITE_ASSET__C8B0Myfy__"